<template>
    <div class="floating-label-container">
        <label data-v-1542780d="" class="floating-label has-value"> {{ placeholder }} </label>
        <Dropdown v-model="weeksValue" :options="weeksNumber" optionLabel="label" optionValue="value"
        :placeholder="placeholder" class="custom-dropdown" size="small" />
    </div>
    
</template>

<script>

import Dropdown from 'primevue/dropdown';

export default {
    components: {
        Dropdown,
    },
    props: {
        weeks: {
            type: [Number, String],
            default: null
        },
        placeholder: {
            type: String,
            default: 'مدة الدراسة'
        },
        tra: {
            type: Object,
            required: true
        }
    },
    computed: {
        weeksValue: {
            get() {
                return this.weeks;
            },
            set(value) {
                this.$emit('update:weeks', value);
            }
        }
    },
    data() {
        return {
            weeksNumber: [],
        };
    },
    methods: {
        generateWeeksOptions() {
            this.weeksNumber = [];
            for (let i = 1; i <= 52; i++) {
                this.weeksNumber.push({
                    label: this.weeksOutput(i),
                    value: i
                });
            }
        },

        weeksOutput(weeks) {
            if (weeks == 1) {
                return this.tra.week;
            } else if (weeks == 2) {
                return this.tra.two_weeks;
            } else {
                return weeks + ' ' + this.tra.weeks;
            }
        }
    },
    mounted() {
        this.generateWeeksOptions();
    },
};
</script>